import React from 'react';
import { Button } from "../../../components/ui/button";

const ScanForm = ({ 
  description, 
  handleDescriptionChange, 
  handleFileChange, 
  handleAddScan, 
  handleSubmit,
  loading 
}) => {
  return (
    <div className="space-y-4 bg-slate-50 p-6 rounded-2xl border border-slate-100 shadow-inner">
      <div className="space-y-2">
        <label className="text-sm font-bold text-slate-700 flex items-center gap-2">
          Document Description <span className="text-red-500 font-black">*</span>
        </label>
        <input
          type="text"
          placeholder="e.g. Pre-Op Chest X-Ray, Lab Results etc."
          value={description}
          onChange={handleDescriptionChange}
          className="w-full p-4 bg-white border border-slate-200 rounded-xl focus:ring-4 focus:ring-teal-100 focus:border-teal-500 outline-none transition-all placeholder:text-slate-400"
        />
      </div>
      
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="flex-1">
          <Button 
            variant="outline" 
            className="w-full h-14 border-2 border-dashed border-slate-300 hover:border-teal-500 hover:text-teal-600 transition-all rounded-xl"
            onClick={() => document.getElementById("fileInput").click()}
          >
            Select Document File
          </Button>
          <input id="fileInput" type="file" className="hidden" onChange={handleFileChange} />
        </div>
        
        <Button 
          className="flex-1 h-14 bg-slate-800 hover:bg-slate-900 text-white font-bold rounded-xl shadow-lg transition-transform active:scale-95" 
          onClick={handleAddScan}
        >
          Add to List
        </Button>
      </div>

      <Button 
        className="w-full h-16 bg-gradient-to-r from-teal-600 to-cyan-600 hover:from-teal-700 hover:to-cyan-700 text-white font-black text-xl rounded-2xl shadow-xl shadow-teal-500/20 transition-all active:scale-[0.98] disabled:opacity-50"
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? (
          <div className="flex items-center gap-3">
            <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            <span>Processing Upload...</span>
          </div>
        ) : (
          "Upload All Documents"
        )}
      </Button>
    </div>
  );
};

export default ScanForm;
